export enum CommittedOrdersApiUrls {
    GetCommittedOrders = '/api/SchedulerConfiguration/GetCommittedOrders',
  }
